import {Howl} from 'howler'
import handleAudioLoadError from '../utils/handleAudioLoadError'
import handleAudioPlayError from '../utils/handleAudioPlayError'

const howl = new Howl({
  src: ['/sounds/shuffle-out.webm', '/sounds/shuffle-out.mp3'],
  preload: true,
  onloaderror: handleAudioLoadError,
  onplayerror: handleAudioPlayError,
})

export default howl
